module.exports = __webpack_public_path__ + "static/media/97gal20.13e495a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/97gal/97gal20.jpg
// module id = 240
// module chunks = 0